import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import PageHero from "@/components/sections/PageHero";
import ContentSection from "@/components/sections/ContentSection";
import { getSitemapGroups } from "@/lib/siteRoutes";

const Sitemap = () => {
  useEffect(() => {
    document.title = "Sitemap | Hadassah Homes";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Browse all pages on the Hadassah Homes website. Find information on buying, selling, investing, property preparation, and more.");
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://hadassahhomesinc.com/sitemap";
  }, []);

  const groups = getSitemapGroups();

  return (
    <SiteLayout>
      <PageHero eyebrow="Navigation" title="Sitemap" subtitle="Browse All Pages on Our Website" compact />

      <ContentSection>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-16">
          {groups.map((group) => (
            <div key={group.title}>
              <h2 className="font-headline text-xl md:text-2xl text-foreground mb-5">{group.title}</h2>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="font-body text-muted-foreground hover:text-accent transition-colors duration-200 text-sm md:text-base"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </ContentSection>
    </SiteLayout>
  );
};

export default Sitemap;
